<template>
  <v-expansion-panels accordion v-model="panel" multiple>

    <!-- DATE SELECTOR PANEL-->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Input Upload and Download
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-col mx-0 px-0>
          <!-- Creating Input Download -->
          <v-btn block outlined large color="primary" @click="downloadInput()">
            Download Input Parameters
          </v-btn>
        </v-col>
        <v-col mx-0 px-0>
          <!-- Creating File Input -->
          <v-file-input filled dense
            v-model = "uploadFile"
            accept=".json, .JSON"
            label="Upload Input Parameters"
            chips
            prepend-icon=""
          ></v-file-input>
        </v-col>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- DATE SELECTOR PANEL-->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Date Picker 
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-menu :close-on-content-click="false" min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="dateRangeText" readonly v-bind="attrs" v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="dates" range no-title scrollable>
          </v-date-picker>
        </v-menu>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- GENERAL SELECTOR PANEL: item var starts with g_ -->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> General 
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-menu :close-on-content-click="false" min-width="auto">
          <template v-slot:activator="{ on, attrs }">

          <v-text-field
            v-model="general.bldngTotVentVol"
            type = 'number'
            label="Building Total Ventilated Volume [m^3]"
            @change="general.bldngTotVentVol = parseFloat(general.bldngTotVentVol)"
          ></v-text-field>
          <v-select
            v-model="general.envHeatCap"
            :items="g_envHeatCap"
            label="Envelope Heat Capacity"
          ></v-select>
          <v-text-field
            v-model="general.bldngHeight"
            type = 'number'
            label="Building Height [m]"
            @change="general.bldngHeight = parseFloat(general.bldngHeight)"
          ></v-text-field>
          </template>
        </v-menu>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- Lighting SELECTOR PANEL: item var starts with l_ -->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Lighting 
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-menu :close-on-content-click="false" min-width="auto">
          <template v-slot:activator="{ on, attrs }">

          <v-text-field
            v-model="lighting.daylightFactor"
            type = 'number'
            label="Lighting daylighting factor"
            @change="lighting.daylightFactor = parseFloat(lighting.daylightFactor)"
          ></v-text-field>
          <v-text-field
            v-model="lighting.annualParasiticEnergy"
            type = 'number'
            label= "Annual parasitic energy (kWh/m2/yr)"
            hint = "Used for emergency lighting and automatic lighting controls"
            @change="lighting.annualParasiticEnergy = parseFloat(lighting.annualParasiticEnergy)"
            persistent-hint
          ></v-text-field>
          <v-select
            v-model="lighting.parasiticEnergy"
            :items="l_parasiticEnergy"
            label="Is parasitic lighting energy considered"
          ></v-select>
          <v-text-field
            v-model="lighting.occFactor"
            type = 'number'
            label="Lighting occupancy factor"
            @change="lighting.occFactor = parseFloat(lighting.occFactor)"
          ></v-text-field>
          <v-text-field
            v-model="lighting.constIlluminationCntrlFactor"
            type = 'number'
            label="Lighting constant illumination control factor"
            @change="lighting.constIlluminationCntrlFactor = parseFloat(lighting.constIlluminationCntrlFactor)"
          ></v-text-field>
          </template>
        </v-menu>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--COP SELECTOR PANEL -->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Heating and Cooling Plants
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-menu :close-on-content-click="false" min-width="auto">
          <template v-slot:activator="{ on, attrs }">

          <v-text-field
            v-model="COP.Heating"
            type = 'number'
            label="Heating COP [kW/kW]"
            @change="COP.Heating = parseFloat(COP.Heating)"
          ></v-text-field>
          <v-text-field
            v-model="COP.Cooling"
            type = 'number'
            label= "Cooling COP [kW/kW]"
            @change="COP.Cooling = parseFloat(COP.Cooling)"
          ></v-text-field>

          </template>
        </v-menu>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!-- HVAC SELECTOR PANEL: item var starts with h_ -->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> HVAC
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-menu :close-on-content-click="false" min-width="auto">
          <template v-slot:activator="{ on, attrs }">

          <v-select
            v-model="HVACsys.sysType"
            :items="h_sysType"
            label="HVAC system type"
            hint='System / Heat dist. method / Cold dist. method / Temp. control'
            persistent-hint
          ></v-select>
          <v-select
            v-model="HVACsys.bemSysType"
            :items="h_bemSysType"
            label="Type of BEM system installed"
          ></v-select>
          <v-select
            v-model="HVACsys.pmpCntrlHeating"
            :items="h_pmpCntrlHeating"
            label="Pump control for heating"
          ></v-select>          
          <v-select
            v-model="HVACsys.pmpCntrlCooling"
            :items="h_pmpCntrlCooling"
            label="Pump control for cooling"
          ></v-select>
          <v-text-field
            v-model="HVACsys.fanFlowCntrlFactor"
            type = 'number'
            label="Fan flow control factor"
            @change="HVACsys.fanFlowCntrlFactor = parseFloat(HVACsys.fanFlowCntrlFactor)"
          ></v-text-field>
          <v-text-field
            v-model="HVACsys.specificFanPower"
            type = 'number'
            label="Specific fan power (W/(l/s))"
            @change="HVACsys.specificFanPower = parseFloat(HVACsys.specificFanPower)"
          ></v-text-field>
          <v-text-field
            v-model="HVACsys.airLeakageLevel"
            type = 'number'
            label="Air leakage level (m3/h/area at Q4Pa)"
            @change="HVACsys.airLeakageLevel = parseFloat(HVACsys.airLeakageLevel)"
          ></v-text-field>
          <v-select
            v-model="HVACsys.exhaustAirCircul"
            :items="h_exhaustAirCircul"
            label="Exhaust Air Circulation"
          ></v-select>          
          <v-select
            v-model="HVACsys.heatRecoveryType"
            :items="h_heatRecoveryType"
            label="Heat Recovery Type"
          ></v-select>
          <v-text-field
            v-model="HVACsys.extraVentilation"
            type = 'number'
            label="Extra Ventilation (liters/s)"
            @change="HVACsys.extraVentilation = parseFloat(HVACsys.extraVentilation)"
          ></v-text-field>          
          <v-select
            v-model="HVACsys.ventCoolingType"
            :items="h_ventCoolingType"
            label="Ventilation and Cooling Type"
          ></v-select>
          <v-col cols="12" mx-0 px-0> </v-col> <!--Just a simple spacer for legibility-->
          
          </template>
        </v-menu>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--DWH SELECTOR PANEL: item var starts with d_ -->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Domestic Hot Water System
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-menu :close-on-content-click="false" min-width="auto">
          <template v-slot:activator="{ on, attrs }">

          <v-select
            v-model="DHWsys.distSys"
            :items="d_distSys"
            label="DHW distribution system"
          ></v-select>
          <v-select
            v-model="DHWsys.genSys"
            :items="d_genSys"
            label="DHW generation system"
          ></v-select>

          </template>
        </v-menu>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--PV SELECTOR PANEL: item var starts with p_ -->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Photovoltaic System
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-menu :close-on-content-click="false" min-width="auto">
          <template v-slot:activator="{ on, attrs }">

          <v-text-field
            v-model="PVsys. moduleSurfaceArea"
            type = 'number'
            label="PV module Surface Area (m2)"
            @change="PVsys. moduleSurfaceArea = parseFloat(PVsys. moduleSurfaceArea)"
          ></v-text-field>  
          <v-text-field
            v-model="PVsys.sysPerformanceFactor"
            type = 'number'
            label="PV system performance factor (level of ventilation)"
            @change="PVsys.sysPerformanceFactor = parseFloat(PVsys.sysPerformanceFactor)"
          ></v-text-field>  
          <v-text-field
            v-model="PVsys.panelPeakPowerCoeff"
            type = 'number'
            label="PV panel peak power coefficient (kW/m2)"
            @change="PVsys.panelPeakPowerCoeff = parseFloat(PVsys.panelPeakPowerCoeff)"
          ></v-text-field>  
          <v-select
            v-model="PVsys.moduleAngle"
            :items="p_moduleAngle"
            label="PV Module Angle (tilt in degrees)"
          ></v-select>
          <v-select
            v-model="PVsys.moduleOrientation"
            :items="p_moduleOrientation"
            label="PV Module Orientation"
          ></v-select>

          </template>
        </v-menu>
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>

<!-- Expansion Panel for Non-Essential Inputs -->


</template>

<script>
export default {
  data: () => ({
    uploadFile: null,
    uploadData: null,

    //-------------------DEFAULT SELECTIONS LISTED HERE ------------------------- //
    dates: ['2020-05-01', '2020-05-10'],
    panel: [0, 1],
    general: {
      bldngTotVentVol: 18348,
      bldngHeight: 9,
      envHeatCap: 'Medium: 165,000 * Af'
    },
    lighting: {
      daylightFactor: 0.8,
      occFactor: 0.8,
      constIlluminationCntrlFactor: 0.8,
      parasiticEnergy: 'Yes',
      annualParasiticEnergy: 6,
    },
    COP: {
      Heating: 3.4,
      Cooling: 3.95,
    },
    HVACsys: {
      sysType: '22. Variable air volume / Water or Water&Air / Water / Yes',
      ventCoolingType: '1. Mechanical system only; no provision for natural ventilation',
      extraVentilation: 0,
      heatRecoveryType: 'Heat exchange plates or pipes (0.65)',
      exhaustAirCircul: 'No exhaust air recirculation',
      airLeakageLevel: 12,
      specificFanPower: 1,
      fanFlowCntrlFactor: 1,
      pmpCntrlCooling: 'All other cases',
      pmpCntrlHeating: 'All other cases',
      bemSysType: 2,
    },
    DHWsys: {
      distSys: 'Taps More Than 3m from Heat Generation',
      genSys: 'Heat Pump (1.4)',
    },
    PVsys: {
      moduleSurfaceArea: 1495.65,
      moduleOrientation: 'S',
      moduleAngle: 30,
      panelPeakPowerCoeff: 0.22,
      sysPerformanceFactor: 0.81,
    },
//-------------------SELECTION ITEMS OPTIONS LISTED HERE ------------------------- //
    g_envHeatCap: [
      'Very Light: 80,000 * Af',
      'Light: 110,000 * Af',
      'Medium: 165,000 * Af',
      'Heavy: 260,000 * Af',
      'Very Heavy: 370,000 * Af',
    ],
    l_parasiticEnergy: [
      'Yes',
      'No',
    ],
    h_sysType: [
      '1. No airco system / Water or Water&Air / NA / Yes',
      '2. No airco system / Water or Water&Air / NA / No',
      '3. No airco system / Air / NA / Yes',
      '4. No airco system / Air / NA / No', 
      '5. Single duct system / Water or Water&Air / Water / Yes',
      '6 .Single duct system / Water or Water&Air / Air / Yes',
      '7. Single duct system / Water or Water&Air / Air / No',
      '8. Single duct system / Air / Air / Yes',
      '9. Single duct system / Air / Air / No',
      '10. Dual duct system / Water or Water&Air / Water / Yes',
      '11. Dual duct system / Water or Water&Air / Air / Yes',
      '12. Dual duct system  / Water or Water&Air / Air / No',
      '13. Dual duct system / Air / Water / Yes',
      '14. Single duct, Terminal reheat / Water or Water&Air / Water / Yes',
      '15. Single duct, Terminal reheat / Water or Water&Air / Air / Yes', 
      '16. Single duct, Terminal reheat / Water or Water&Air / Air / No',
      '17. Constant volume / Water or Water&Air / Water / Yes',
      '18. Constant volume / Water or Water&Air / Air / Yes',
      '19. Constant volume / Water or Water&Air / Air / No',
      '20. Constant volume / Air  / Air / Yes',
      '21. Constant volume / Air / Air / No',
      '22. Variable air volume / Water or Water&Air / Water / Yes',
      '23. Variable air volume / Water or Water&Air / Air / Yes',
      '24. Variable air volume / Water or Water&Air / Air / No',
      '25. Fan coil system, 2-pipe',
      '26. Fan coil system, 3-pipe',
      '27. Fan coil system, 4-pipe',
      '28. Induction system, 2-pipe non change over',
      '29. Induction system, 2-pipe change over',
      '30. Induction system, 3-pipe',
      '31. Induction system, 4-pipe',
      '32. 2-pipe radiant cooling panels (chilled ceilings & passive chilled beams)',
      '33. 4-pipe radiant cooling panels (chilled ceilings & passive chilled beams)',
      '34. Embedded cooling system floors, walls or ceilings',
      '35. Room units including single duct units',
      '36. Direct expansion single split system',
      '37. Direct expansion single split system including variable refrigerant flow systems',
    ],
    h_ventCoolingType: [
      '1. Mechanical system only; no provision for natural ventilation',
      '2. Mech. w/ optimal natural outside air cooling (whenever possible)',
      '3. Same as 2, with fully natural fresh air supply (always)',
    ],
    h_heatRecoveryType: [
      'No heat recovery',
      'Heat exchange plates or pipes (0.65)',
      'Two-elements-system (0.6)',
      'Loading cold with air-conditioning (0.4)',
      'Heat-pipes (0.6)',
      'Slowly rotating or intermittent heat exchangers (0.7)',
    ],
    h_exhaustAirCircul: [
      'No exhaust air recirculation',
      'Exhaust air recirculation 20%',
      'Exhaust air recirculation 40%',
      'Exhaust air recirculation 60%',
    ],
    h_pmpCntrlCooling: [
      'No pump for cooling',
      'Automatic control more than 50%',
      'All other cases',
    ],
    h_pmpCntrlHeating: [
      'No pump for heating',
      'Automatic control more than 50%',
      'All other cases',
    ],
    h_bemSysType: [
      1,
      2,
      3,
      4,
    ],
    d_distSys: [
      'All Taps Within 3m from Heat Generation',
      'Taps More Than 3m from Heat Generation',
      'Circulation system or Unknown',
    ],
    d_genSys: [
      'Electric (0.75)',
      'VR-Boiler (0.61)',
      'Gas Boiler, HR-Boiler (0.75)',
      'Co-Generation (0.9)',
      'District Heating (0.9)',
      'Heat Pump (1.4)',
      'Steam (0.61)',
    ],
    p_moduleOrientation: [
      'S',
      'SE',
      'E',
      'W',
      'SW',
    ],
    p_moduleAngle: [
      0,
      30,
      45,
      60,
      90,
    ],

//-------------------End of Selection Items ------------------------- //
  }),
  methods: {
    updateVar() {
      this.$store.commit("updateDTW_basicParam",[
        this.general,this.lighting, this.COP, this.HVACsys, this.DHWsys, this.PVsys
      ])
    },
    downloadInput() {
      this.$store.commit("updateDTW_date",this.dates.sort())
      this.updateVar()
      this.$store.commit("updateDTW_run",'updateVar2_download')
    },
    uploadInput() {
      let obj = this.uploadData

      this.dates = [obj.start, obj.end]
      this.general = obj.general
      this.lighting  = obj.lighting
      this.COP = obj.COP
      this.HVACsys = obj.HVACsys
      this.DHWsys = obj.DHWsys
      this.PVsys = obj.PVsys

      this.$store.commit("updateDTW_date", this.dates)
      this.updateVar()
      this.$store.commit("updateDTW_advParam",[
        obj.zone_table, obj.envelope_table, obj.material_table, obj.schedule_table, obj.calibration_table,
      ])
      this.$store.commit("updateDTW_run",'updateVar2_upload')
    },
    async openFile(file) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.onload = event => resolve(JSON.parse(event.target.result))
        fileReader.onerror = error => reject(error)
        fileReader.readAsText(file)
      })
    },
  },
  watch: {
    '$store.state.DTW.run': function() {
        if (this.$store.state.DTW.run === "updateVar1") {
          this.updateVar()
          this.$store.commit("updateDTW_run",'updateVar2')
        }
      },
    'uploadFile': async function() {
        if (this.uploadFile !== null) {
          this.uploadData = await this.openFile(this.uploadFile)
          this.uploadInput()
        }
      }
  },
  computed: {
    dateRangeText () {
      this.$store.commit("updateDTW_date",this.dates.sort())
      return ' '.concat(this.dates.sort().join(' ~ '))
    },
  },
}
</script>
